<template>
	<Popup
		v-model="selfDisplay"
		title="修改"
		confirmBtnText="修改"
		@confirmClick="handleUpdateClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>上传图片</span>
				<div v-if="!img" class="b_upload b_inline_block">
					<el-button type="primary">点击上传</el-button>
					<input type="file" accept="image/*" @change="handleImgUpload"/>
					<span class="b_upload_tip">请上传jpg或者png图片！！！</span>
				</div>
				<div v-if="img" class="b_upload b_inline_block" style="border: 1px solid #ccc;">
					<img :src="img" alt="" style="">
					<i @click="handleImgDelete"></i>
				</div>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="imgTip"><i class="b_icon"></i>请上传图片</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>序号</span>
				<el-input v-model="order" placeholder="序号"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="orderTip"><i class="b_icon"></i>请输入整数</template></div>
						
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>名称</span>
				<el-input v-model="name" placeholder="名称"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="nameTip"><i class="b_icon"></i>请输入名称</template></div>
			
			<div class="base_form_row">
				<span class="b_label">链接</span>
				<el-input v-model="link" placeholder="链接"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="linkTip"><i class="b_icon"></i>请输入链接</template></div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../api/index.js';
	import BaseMethods from '../../../../../../assets/js/base.js';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			obj: {
				type: Object,
				default() { return {}; }
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				img: '',
				order: 1,
				name: '',
				link: '',
				imgTip: false,
				orderTip: false,
				nameTip: false,
				linkTip: false
			}
		},
		methods: {
			// 点击修改
			handleUpdateClick() {
				if (!this.img) {
					this.imgTip = true;
					return false;
				} else {
					this.imgTip = false;
				}
				if (!this.positiveReg.test(this.order)) {
					this.orderTip = true;
					return false;
				} else {
					this.orderTip = false;
				}
				if (!this.name.trim()) {
					this.nameTip = true;
					return false;
				} else {
					this.nameTip = false;
				}
				if (!this.link.trim()) {
					this.linkTip = true;
					return false;
				} else {
					this.linkTip = false;
				}
				this.update();
			},
			// 修改
			update() {
				const that = this;
				that.loading = true;
				let requestData = {
					id: that.obj.id,
					orderNum: that.order,
					cardName: that.name,
					cardImg: that.img,
					linkUrl: that.link
				};
				Api.updateIAssistantCard(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 上传图片
			handleImgUpload(e) {
				const that = this;
				BaseMethods.uploadMultiImg(e, (base64, imgs_type, imgs_name) => {
					that.uploadImg(base64[0], imgs_type[0], imgs_name[0]);
				}, (msg) => {
					that.$message.error(msg);
				});
			},
			// 删除上传的图片
			handleImgDelete() {
				this.img = '';
			},
			// 上传图片
			uploadImg(base64, img_type, fileName) {
				const that = this;
				that.loading = true;
				let postName = `${ new Date().getTime() }_${ fileName }`;
				let requestData = {
					base: base64,
					picName: postName,
					type: 'uGateWayUrl'
				};
				Api.uploadPic(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.img = res.data.data.imgUrl.split('?')[0];
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.loading = false;
					this.img = this.obj.img;
					this.order = this.obj.order;
					this.name = this.obj.name;
					this.link = this.obj.link;
					this.imgTip = false;
					this.orderTip = false;
					this.nameTip = false;
					this.linkTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
